import api from './axiosConfig';
import avatar1 from 'assets/img/team/72x72/avatarsysadmin.png';
import avatar2 from 'assets/img/team/72x72/avatarsysadminops.png';
import avatar3 from 'assets/img/team/72x72/avatarsysadminqa.png';
import avatar4 from 'assets/img/team/72x72/avatarmemberqa.png';
import avatar5 from 'assets/img/team/72x72/avatarmemberops.png';

export interface Account {
  fullname: string;
  id: number;
  activation_code: boolean;
  username: string;
  email: string;
  registerat: string;
  last_seen: string;
  roles: string;
  avatar?: string;
  auth_type?: 'local' | 'saml-azure' | 'saml-manageengine';
}

export interface OneAccount {
  name: string;
  lastname: string;
  username: string;
  email: string;
  activation_code: boolean;
  roles: string;
  auth_type?: 'local' | 'saml-azure' | 'saml-manageengine';
}

export const fetchAccounts = async (): Promise<Account[]> => {
  try {
    const response = await api.get('accounts');

    // eslint-disable-next-line
    return response.data.map((account: any) => {
      const roles = account.roles;
      let avatar = '';
      if (roles.includes('systemadmin')) {
        avatar = avatar1;
      } else if (roles.includes('opsadmin')) {
        avatar = avatar2;
      } else if (roles.includes('qaadmin')) {
        avatar = avatar3;
      } else if (roles.includes('qamember')) {
        avatar = avatar4;
      } else {
        avatar = avatar5;
      }
      return {
        fullname: account.fullname,
        id: account.id,
        activation_code: account.activation_code,
        username: account.username,
        email: account.email,
        registerat: new Date(account.registerat).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        }),
        last_seen: new Date(account.last_seen).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        }),
        roles: account.roles,
        avatar,
        auth_type: account.auth_type
      };
    });
  } catch (error) {
    console.error('Error fetching accounts:', error);
    throw error;
  }
};

export const deleteAccount = async (id: number): Promise<void> => {
  try {
    await api.delete(`${id}/accountdelete/`);
    console.log(`Account deleted successfully`);
  } catch (error) {
    console.error(`Error deleting account with id ${id}:`, error);
    throw error;
  }
};

export const getAccount = async (id: number): Promise<OneAccount> => {
  try {
    const response = await api.get(`${id}/account/`);

    if (!response.data) {
      throw new Error('Failed to fetch user data');
    }

    const accountData = response.data;

    return {
      name: accountData.name,
      lastname: accountData.lastname,
      username: accountData.username,
      email: accountData.email,
      activation_code: !!accountData.activation_code,
      auth_type: accountData.auth_type,
      roles: accountData.roles // Convert roles string to array roles: accountData.roles.split(',')
    };
  } catch (error) {
    console.error(`Error fetching account with id ${id}:`, error);
    throw error;
  }
};
